import { ApiCore } from "@/services/api/utils/core.js";
import { apiProvider } from "@/services/api/utils/provider.js";
import axios from "axios";
import { handleResponse, handleError } from "@/services/api/utils/response.js";

const url = "v1/package";

const api = new ApiCore({
	index: true,
	create: true,
	url: url,
});

api.getAllFolders = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/folders`, { params })
		.then(handleResponse)
		.catch(handleError);
};

api.getFolder = (id) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/folders/${id}`)
		.then(handleResponse)
		.catch(handleError);
};

api.createFolder = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/folder`, payload)
		.then(handleResponse)
		.catch(handleError);
};

api.movePackage = (id, payload, options) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${id}/folder`, payload, options)
		.then(handleResponse)
		.catch(handleError);
};

api.renameFolder = (id, payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/folders/${id}`, payload)
		.then(handleResponse)
		.catch(handleError);
};

api.deleteFolder = (id) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}/folders/${id}`)
		.then(handleResponse)
		.catch(handleError);
};

export default api;
